const getAccountReportInfo = ({startDate, endDate, account}) => {
  const transitCards = account?.transitAccounts?.[0]?.transitCards ?? [];

  // Build filtered, annotated scans without mutating originals
  const scans = transitCards.flatMap(card =>
    (card?.scans ?? [])
      .filter(scan => inDateRange(scan?.created, startDate, endDate))
      .map(scan => ({
        ...scan,
        nickname: card?.nickname,
        cardNumber: card?.cardNumber
      }))
  );

  // Exclude line items that match scans by orderId
  const scanOrderIds = new Set(
    scans
      .map(s => (s?.orderId != null ? String(s.orderId) : null))
      .filter(Boolean)
  );

  const orderHistory = (account?.orderHistory?.lineItems ?? [])
    .filter(li => inDateRange(li?.dateTime, startDate, endDate))
    .filter(li => !scanOrderIds.has(String(li?.orderId)));

  return {orderHistory, scans};
};

// Inclusive date range check with Safari-safe parsing for YYYY-MM-DD
const inDateRange = (date, startRange, endRange) => {
  const d = toValidDate(date);
  if (!d) return false;

  const start = toStartOfDay(startRange);
  const end = toEndOfDay(endRange);

  if (start && d < start) return false;
  if (end && d > end) return false;
  return true;
};

// Helpers
const toValidDate = value => {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : d;
};

const parseYMD = s => {
  if (typeof s !== 'string') return null;
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!m) return null;
  const y = Number(m[1]);
  const mo = Number(m[2]);
  const d = Number(m[3]);
  return {y, mo, d};
};

const toStartOfDay = value => {
  if (!value) return null;
  const ymd = parseYMD(value);
  if (ymd) return new Date(ymd.y, ymd.mo - 1, ymd.d, 0, 0, 0, 0);
  const d = toValidDate(value);
  if (!d) return null;
  d.setHours(0, 0, 0, 0);
  return d;
};

const toEndOfDay = value => {
  if (!value) return null;
  const ymd = parseYMD(value);
  if (ymd) return new Date(ymd.y, ymd.mo - 1, ymd.d, 23, 59, 59, 999);
  const d = toValidDate(value);
  if (!d) return null;
  d.setHours(23, 59, 59, 999);
  return d;
};

export default getAccountReportInfo;
